import { jsx, Fragment } from 'react/jsx-runtime';
import { Calendars } from '@ninja/utilities';
import { useWebUIConfigOptions } from './ThemeProvider2.js';
import styles from './DatePicker4.js';
import { useCalendarViewContext } from './components10.js';

const CalendarsView = () => {
    const { viewState: { currentCalendar }, calendars, onCalendarChange, } = useCalendarViewContext();
    const { isRtlLocale } = useWebUIConfigOptions();
    return (jsx(Fragment, { children: jsx("div", { className: "flex justify-evenly flex-grow   gap-2  ", children: calendars.map((calendar) => {
                return (jsx("div", { className: currentCalendar === calendar ? styles.dayViewLink.container : undefined, onClick: () => {
                        onCalendarChange && onCalendarChange(calendar);
                    }, children: jsx("label", { children: Calendars[calendar].name[isRtlLocale ? 'ar' : 'en'] }) }, calendar));
            }) }) }));
};

export { CalendarsView };
